export default "__VITE_ASSET__5HNFz01R__"